// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"8c09b0e0","443":"73410e6b"}[chunkId] + ".chunk.css";
};